import React from 'react';
import type { OperatorCarveOut } from '../../lib/api';

interface Props {
  carveOut: OperatorCarveOut;
  representativeParcelLabel?: string | null;
}

export const CandidateCarveOutPanelV2: React.FC<Props> = ({ carveOut, representativeParcelLabel }) => {
  const acresLabel = carveOut.totalAcres
    ? `${Math.round(carveOut.totalAcres).toLocaleString()} ac`
    : null;
  const parcelCount = carveOut.parcelIds?.length ?? 0;

  return (
    <div className="v2-carve-out">
      <div className="v2-carve-out-eyebrow">
        Candidate carve-out
        {carveOut.positionLabel ? (
          <span className="v2-carve-out-position"> · {carveOut.positionLabel}</span>
        ) : null}
      </div>

      <h3 className="v2-carve-out-name">{carveOut.name}</h3>

      <div className="v2-carve-out-data">
        {acresLabel ? (
          <>
            <div className="v2-pd-label">Acres</div>
            <div className="v2-pd-val">{acresLabel}</div>
          </>
        ) : null}
        {parcelCount > 0 ? (
          <>
            <div className="v2-pd-label">Member parcels</div>
            <div className="v2-pd-val">{parcelCount}</div>
          </>
        ) : null}
        <div className="v2-pd-label">Owner</div>
        <div className="v2-pd-val v2-pd-small">{carveOut.ownerName}</div>
        {representativeParcelLabel ? (
          <>
            <div className="v2-pd-label">Briefed parcel</div>
            <div className="v2-pd-val v2-pd-small">{representativeParcelLabel}</div>
          </>
        ) : null}
      </div>

      {carveOut.description ? (
        <p className="v2-carve-out-prose">{carveOut.description}</p>
      ) : null}

      {carveOut.subdivisionNote ? (
        <div className="v2-carve-out-note">{carveOut.subdivisionNote}</div>
      ) : null}
    </div>
  );
};
